import React from "react";

type StepUi = {
  element?: JSX.Element;
  skip?: boolean;
  heading: string;
  subheading?: string;
};

type Props = {
  steppers: StepUi[];
  currentStep: number;
  submitCount: number;
};

function Stepper({ currentStep, steppers }: Props) {
  return (
    <div className="w-full mb-6">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {steppers.map((step, index) => {
          const stepNum = index + 1;
          const isCompleted = stepNum < currentStep;
          const isActive = stepNum === currentStep;

          return (
            <div key={index} className="flex flex-col gap-1.5">
              <div className="flex items-center gap-1.5 text-xs">
                {isCompleted ? (
                  <span className="w-4 h-4 rounded-full bg-emerald-500 text-slate-950 flex items-center justify-center text-[10px] font-bold shrink-0">
                    ✓
                  </span>
                ) : isActive ? (
                  <span className="w-2 h-2 rounded-full bg-purple-400 animate-pulse shrink-0" />
                ) : (
                  <span className="w-2 h-2 rounded-full bg-slate-400 dark:bg-slate-600 shrink-0" />
                )}
                <span
                  className={`truncate text-xs ${
                    isActive
                      ? "text-purple-600 dark:text-purple-300 font-semibold"
                      : isCompleted
                      ? "text-emerald-600 dark:text-emerald-400 font-medium"
                      : "text-slate-400 dark:text-slate-500"
                  }`}
                >
                  {stepNum}. {step.subheading || step.heading}
                </span>
              </div>
              <div
                className={`h-1 rounded-full transition-all duration-300 ${
                  isCompleted
                    ? "bg-emerald-500"
                    : isActive
                    ? "bg-gradient-to-r from-purple-500 to-indigo-500 shadow-glow-purple"
                    : "bg-slate-200 dark:bg-white/10"
                }`}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Stepper;